import React, { useMemo } from 'react';
import GenericTableFilter from '../../../../../components/common/GenericTableFilter';

const DealerAnnouncementFilters = ({
  filterFields,
  columns,
  customFilterTypes,
  customFilterOptions,
  handleSearch,
  handleApplyFilters,
  handleResetFilters
}) => {
  const initialFilters = useMemo(() => {
    const filters = {};
    if (filterFields && filterFields.length > 0) {
      filterFields.forEach((field) => {
        if (field.field === 'period') {
          filters[field.field] = new Date().getFullYear();
        } else {
          filters[field.field] = '';
        }
      });
    }
    return filters;
  }, [filterFields]);

  return (
    <GenericTableFilter
      filterFields={filterFields}
      columns={columns}
      initialFilters={initialFilters}
      onSearch={handleSearch}
      onApplyFilters={handleApplyFilters}
      onResetFilters={handleResetFilters}
      customFilterTypes={customFilterTypes}
      customFilterOptions={customFilterOptions}
    />
  );
};

export default DealerAnnouncementFilters;
